import Spinner from 'src/javascripts/components/utilities/Spinner';
import Typeahead from "src/javascripts/components/Typeahead";

export default class SurveysEdit {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');
    const existingParams = new URLSearchParams(window.location.search);

    // Reloading //
    const reloadPage = function () {

      let surveyName = $('#survey_name').val();
      let surveyableType = $('.select-record-type:checked').val();
      let surveyIssuerId = $('#survey_issuer_id').val();
      let surveyPortfolioId = $('#survey_portfolio_id').val();
      let surveyStatus = $('#survey_status').val();
      let linkOnly = $('#linkOnlyAccess').length ? $('#linkOnlyAccess').is(':checked') : undefined
      let minCompletion = $('#survey_minimum_completion').val();
      let dataFrom = $('#survey_data_from').val();
      let dataTo = $('#survey_data_to').val();
      let ownerId = $('#survey_owner_id').val();
      let primaryApproverId = $('#survey_primary_approver_id').val();
      let secondaryApproverId = $('#survey_secondary_approver_id').val();
      let surveySubmissionDeadline = $('#survey_submission_deadline').val();
      let surveyApprovalDeadline = $('#survey_approval_deadline').val();
      let submittedAt = $('#survey_submitted_at').val();
      let approvedAt = $('#survey_approved_at').val();
      let surveyTemplateId = $('#surveyTemplatesContainer .ethos-radio:checked').val();
      let assetClass = $('#survey_asset_class').val();
      let params = {};
      if (typeof surveyName !== 'undefined') {params['name'] = surveyName}
      if (typeof surveyableType !== 'undefined') {params['surveyable_type'] = surveyableType}
      if (typeof surveyIssuerId !== 'undefined') {params['issuer_id'] = surveyIssuerId}
      if (typeof surveyPortfolioId !== 'undefined') {params['portfolio_id'] = surveyPortfolioId}
      if (typeof surveyStatus !== 'undefined') {params['status'] = surveyStatus}
      if (typeof linkOnly !== 'undefined') {params['link_only_access'] = linkOnly}
      if (typeof minCompletion !== 'undefined') {params['minimum_completion'] = minCompletion}
      if (typeof dataFrom !== 'undefined') {params['data_from'] = dataFrom}
      if (typeof dataTo !== 'undefined') {params['data_to'] = dataTo}
      if (typeof ownerId !== 'undefined') {params['owner_id'] = ownerId}
      if (typeof primaryApproverId !== 'undefined') {params['primary_approver_id'] = primaryApproverId}
      if (typeof secondaryApproverId !== 'undefined') {params['secondary_approver_id'] = secondaryApproverId}
      if (typeof surveySubmissionDeadline !== 'undefined') {params['submission_deadline'] = surveySubmissionDeadline}
      if (typeof surveyApprovalDeadline !== 'undefined') {params['approval_deadline'] = surveyApprovalDeadline}
      if (typeof submittedAt !== 'undefined') {params['submitted_at'] = submittedAt}
      if (typeof approvedAt !== 'undefined') {params['approved_at'] = approvedAt}
      if (typeof surveyTemplateId !== 'undefined') {params['survey_template_id'] = surveyTemplateId}
      if (typeof assetClass !== 'undefined') {params['asset_class'] = assetClass}
      if (existingParams.get('survey_scope') == 'survey_template'){
        params['survey_scope'] = 'survey_template';
      }

      // Set scroll and reload
      let baseUrl = window.location.pathname;
      let scrollFilter = $('#surveyTemplatesContainer').scrollTop();
      params['sp'] = scrollFilter;

      Turbo.cache.clear();
      Turbo.visit(baseUrl + '?' + $.param(params));
    };

    // Asset class → lock surveyable_type to Portfolio for ABS classes
    const assetClassSelect = $('#survey_asset_class');
    const absClasses = assetClassSelect.data('abs-classes') || [];

    const enforceAssetClassConstraint = function() {
      const selected = assetClassSelect.val();
      const isAbs = absClasses.includes(selected);
      $('#surveyableIssuer').prop('disabled', isAbs);
      $('#surveyableTypeFields label[for="surveyableIssuer"]').toggleClass('text-muted', isAbs);
      if (isAbs && $('#surveyableIssuer').is(':checked')) {
        $('#surveyablePortfolio').prop('checked', true).trigger('change');
      }
    };

    assetClassSelect.on('change', function() {
      enforceAssetClassConstraint();
      reloadPage();
    });
    // enforceAssetClassConstraint() is called after .select-record-type is bound below

    /********************/
    // Survey templates
    /********************/
    $('#survey_templates_filter').keyup(function() {
      let val = $(this).val().toLowerCase();
      $('#surveyTemplatesContainer .template-option').filter(function() {
        let t = ($(this).data('template-name') || '').toLowerCase();
        let d = ($(this).data('template-description') || '').toLowerCase();
        if ((t.indexOf(val) === -1) && (d.indexOf(val) === -1)) {
          $(this).removeClass('d-flex').addClass('d-none');
        } else {
          $(this).removeClass('d-none').addClass('d-flex');
        }
      });
    })

    $('#surveyTemplatesContainer .ethos-radio').change(function() {
      const templateAssetClass = $(this).data('asset-class');
      const absClasses = assetClassSelect.data('abs-classes') || [];
      if (templateAssetClass) {
        assetClassSelect.val(templateAssetClass);
        if (absClasses.includes(templateAssetClass)) {
          $('#surveyablePortfolio').prop('checked', true);
          enforceAssetClassConstraint();
        }
      }
      reloadPage();
    })

    // Scroll templates container on load
    let p = $('#surveyTemplatesContainer').data("scroll-p");
    if (typeof p !== "undefined") {
      $('#surveyTemplatesContainer').scrollTop(p);
    }

    // Enable link-only access
    $('#linkOnlyAccess').on('change', function() {
      if ($(this).is(":checked")) {
        $('#surveySlugContainer').removeClass('d-none');
      } else {
        $('#surveySlugContainer').addClass('d-none');
      }
    })

    // Min completion
    $('#minimum_completion_percent').blur(function() {
      let val = $(this).val() / 100;
      $(this).closest('.form-group').find('.hidden-input').val(val);
    })

    // Select pre-populate option
    $(".pre-populate-option").on('change', function () {
      let prePopString = '';
      let hiddenPrePop = $('#hidden_pre_pop');
      $(".pre-populate-option").each(function() {
        if ($(this).is(":checked")) {
          prePopString += $(this).val();
          prePopString += '|'
        }
      });
      hiddenPrePop.val(prePopString);
      if ($(this).attr('id') === 'useSurvey') {
        setTimeout(function() {
          $('#previous_survey_search').focus();
        }, 300);
      }
    });

    // Select record type
    $(".select-record-type").change(function () {
      let val = $(this).val();
      $('.select-reportable-id').addClass('d-none');
      $('.select-reportable-id[data-reportable-type=' + val + ']').removeClass('d-none');
      $('.select-reportable-id').find('.twitter-typeahead input').typeahead('val', '');
      $('.select-reportable-id').find('.hidden-validation-input').val('');
    });

    // Apply asset class constraint now that the record-type handler is bound
    enforceAssetClassConstraint();

    // Restore hidden_pre_pop after the generic clear-typeahead handler wipes all hidden
    // fields in the parent form-group, which would otherwise clear the pre-populate option.
    // setTimeout defers execution until after all synchronous click handlers (including
    // the Typeahead.js clear handler) have completed.
    $("#prevSurveySection .clear-typeahead")
      .off('click.restorePrePop')
      .on('click.restorePrePop', function () {
        setTimeout(function () {
          $(".pre-populate-option").first().trigger('change');
        }, 0);
      });

    // Select pre-populate option
    $("#useSurvey").change(function () {
      let prePop = $(this).is(":checked");
      if (prePop === true) {
        $("#prevSurveySection").removeClass("d-none");
      } else {
        $("#prevSurveySection").addClass("d-none");        
      }
    });


  }

}